import { render, staticRenderFns } from "./tmscoldChainList_SF.vue?vue&type=template&id=4619f3df&scoped=true"
import script from "./tmscoldChainList_SF.vue?vue&type=script&lang=js"
export * from "./tmscoldChainList_SF.vue?vue&type=script&lang=js"
import style0 from "./tmscoldChainList_SF.vue?vue&type=style&index=0&id=4619f3df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4619f3df",
  null
  
)

export default component.exports